import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

const setFavicon = (url) => {
  if (!url) return;
  const link = document.querySelector("link[rel~='icon']") || Object.assign(document.createElement("link"), { rel: "icon" });
  link.href = url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
  document.head.appendChild(link);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(() => { try { return JSON.parse(localStorage.getItem("wimnw_config")); } catch { return null; } });

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshConfig = useCallback(() => api.get("/config").then((r) => { setConfig(r.data); setFavicon(r.data?.branding?.logo_url); try { localStorage.setItem("wimnw_config", JSON.stringify(r.data)); } catch { /* storage full */ } }).catch(() => {}), []);
  useEffect(() => { refreshConfig(); }, [refreshConfig]);

  useEffect(() => {
    // Returning from OAuth: AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, config, logout, checkAuth, refreshConfig }}>{children}</AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
